import { PAGE_ROUTES } from '../constants/pageRoutes';
import PERMISSION_KEYS from '../constants/permissionKeys';

type MenuNode = {
	path?: string | null;
	subMenu?: Record<string, MenuNode> | null;
};

const normalizePath = (path: string): string => {
	const trimmed = String(path || '').trim();
	if (!trimmed || trimmed === '/') return '/';
	return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

const isDashboardPath = (path: string): boolean => {
	const n = normalizePath(path);
	return n === '/' || n === `/${PAGE_ROUTES.DASHBOARD}`;
};

export const findFirstMenuPath = (
	menu: Record<string, MenuNode> | null | undefined,
	options?: { skipDashboard?: boolean },
): string | null => {
	if (!menu) return null;
	const skipDashboard = Boolean(options?.skipDashboard);

	const walk = (nodes: MenuNode[]): string | null => {
		for (const node of nodes) {
			if (node) {
				const path = node.path != null ? String(node.path).trim() : '';
				if (path) {
					const full = normalizePath(path);
					if (!(skipDashboard && isDashboardPath(full))) return full;
				}
				if (node.subMenu && typeof node.subMenu === 'object') {
					const nested = walk(Object.values(node.subMenu));
					if (nested) return nested;
				}
			}
		}
		return null;
	};

	return walk(Object.values(menu));
};

export const resolveHomePath = (
	canRead: (permissionKey: string) => boolean,
	dynamicMenu: Record<string, MenuNode>,
): string => {
	if (canRead(PERMISSION_KEYS.DASHBOARD) || canRead('dashboard')) {
		return '/';
	}
	const first = findFirstMenuPath(dynamicMenu, { skipDashboard: true });
	if (first) return first;
	return `/${PAGE_ROUTES.PROFILE}`;
};